export const AI_TEXT_CREATOR_ENTRY_POINT_ORIGIN = 'text container';
